<div class="driver-sos-details-dialog">

  <div class="driver-sos-details-dialog__close-btn" (click)="close()" cdkFocusRegionstart>
    <span class="material-icons">close</span>
  </div>

  <div class="driver-sos-details-dialog__content">
    <div class="driver-sos-details-dialog__content__logos">
      <img [src]="logoSosUrl" class="driver-sos-details-dialog__content__logos__sos-logo" alt="">
      <img [src]="logoUrl" class="driver-sos-details-dialog__content__logos__logo" alt="">
    </div>

    <div class="driver-sos-details-dialog__content__header">
      <div class="driver-sos-details-dialog__content__header__title">
        <span class="text-primary">{{ 'DRIVER_SOS_DETAILS_DIALOG.HEADER.title' | translate }}</span>,
      </div>
      <div  class="driver-sos-details-dialog__content__header__subtitle"
            [innerHTML]="'DRIVER_SOS_DETAILS_DIALOG.HEADER.subtitle' | translate | safeHtml">
      </div>
      <div  class="driver-sos-details-dialog__content__header__description"
            [innerHTML]="'DRIVER_SOS_DETAILS_DIALOG.HEADER.description' | translate | safeHtml">
      </div>
    </div>

    <div class="driver-sos-details-dialog__content__details">
      <div class="driver-sos-details-dialog__content__details__title">
        {{ 'DRIVER_SOS_DETAILS_DIALOG.DETAILS.title' | translate }}
      </div>
      <ul class="driver-sos-details-dialog__content__details__list">
        <li><img [src]="checkIconUrl" alt="">{{ 'DRIVER_SOS_DETAILS_DIALOG.DETAILS.LIST.item2' | translate }}</li>
        <li><img [src]="checkIconUrl" alt="">{{ 'DRIVER_SOS_DETAILS_DIALOG.DETAILS.LIST.item3' | translate }}</li>
        <li><img [src]="checkIconUrl" alt="">{{ 'DRIVER_SOS_DETAILS_DIALOG.DETAILS.LIST.item4' | translate }}</li>
        <li><img [src]="checkIconUrl" alt="">{{ 'DRIVER_SOS_DETAILS_DIALOG.DETAILS.LIST.item5' | translate }}</li>
      </ul>
    </div>

    <div class="driver-sos-details-dialog__content__button">
      <button (click)="close()" class="btn btn--secondary">
        {{ 'DRIVER_SOS_DETAILS_DIALOG.buttonText' | translate }}
      </button>
    </div>
  </div>

  <div class="driver-sos-details-dialog__image">
    <img [src]="rightImageUrl" alt="">
  </div>

</div>
